document.addEventListener('DOMContentLoaded', function() {
  const toggleBtn = document.querySelector('[data-filter-toggle]');
  const sidebar = document.getElementById('CollectionSidebar');
  const overlay = document.getElementById('CollectionSidebarOverlay');
  const closeBtn = document.querySelector('[data-filter-close]');
  const toggleText = document.querySelector('.filter-toggle-btn__text');

  if (!toggleBtn || !sidebar) return;

  function toggleSidebar() {
    const isMobile = window.innerWidth < 750;

    if (isMobile) {
      // Mobile popup drawer toggle
      sidebar.classList.toggle('open');
      overlay.classList.toggle('open');
      document.body.classList.toggle('overflow-hidden');
    } else {
      // Desktop collapse toggle
      const isHidden = sidebar.classList.toggle('hidden');
      toggleBtn.setAttribute('aria-expanded', !isHidden);
      
      if (toggleText) {
        toggleText.textContent = isHidden 
          ? toggleText.getAttribute('data-toggle-text-show') 
          : toggleText.getAttribute('data-toggle-text-hide');
      }
    }
  }

  toggleBtn.addEventListener('click', toggleSidebar);

  if (closeBtn) {
    closeBtn.addEventListener('click', function() {
      sidebar.classList.remove('open');
      overlay.classList.remove('open');
      document.body.classList.remove('overflow-hidden');
    });
  }

  if (overlay) {
    overlay.addEventListener('click', function() {
      sidebar.classList.remove('open');
      overlay.classList.remove('open');
      document.body.classList.remove('overflow-hidden');
    });
  }
});
